/**
 * Portal SharePoint route — now a redirect to /c/$slug/desktop.
 *
 * The prior 3-pane bespoke surface had no folder drill-down, no file
 * preview, and no save-back. The Win95 Desktop at /desktop already
 * exposes all of that (TreePane, DocumentPreview, ImportWizard, context
 * menus). Unifying on one surface eliminated duplicate code and gave
 * lawyer-evaluators a consistent file-browsing UX.
 *
 * Kept as a redirect (not deleted) so deeplinks like
 * `/c/${slug}/sharepoint` continue to work — TenantChrome's "What is
 * this?" panel and a few e2e specs reference the URL.
 */

import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { useTenantBranding } from '../../../lib/tenant/TenantBrandingContext';

function PortalSharepointRedirect() {
  const { slug } = useTenantBranding();
  const navigate = useNavigate();

  useEffect(() => {
    void navigate({
      to: '/c/$clientSlug/desktop',
      params: { clientSlug: slug },
      replace: true,
    });
  }, [navigate, slug]);

  return null;
}

export const Route = createFileRoute('/c/$clientSlug/sharepoint')({
  component: PortalSharepointRedirect,
});
